export default {
  name: 'back-website',

  events: [
    {
      on: 'click',
      handle(e) {
        e.preventDefault()

        if (this.props.p) {
          window.location.href = this.props.p
        } else if (document.referrer.indexOf(window.location.host) >= 0) {
          let historyBackCount = 1
          if (this.props !== 'undefined' && this.props.isSuccess) {
            historyBackCount = 2
          }

          window.history.go(-historyBackCount)
        } else {
          window.location.href = this.props.hp
        }
      },
    },
  ],
}
